import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { cidadesService, ufService } from '../../services';
import { Cidade } from '../../types/pessoas';
import { makeOptionLoader } from '../../utils/optionLoaders';

const fields: ResourceField<Cidade>[] = [
  { name: 'nome', label: 'Cidade', required: true },
  { name: 'codigo_ibge', label: 'Codigo IBGE', required: true },
  {
    name: 'uf',
    label: 'UF',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(ufService.list, (item: any) => item.sigla ?? item.nome),
    required: true,
  },
];

export const CidadesFormPage: React.FC = () => (
  <ResourceFormPage
    title="Nova cidade"
    description="Cadastre cidades para uso em enderecos e entidades."
    fields={fields}
    service={cidadesService}
    redirectPath="/admin/pessoas/cidades"
    cancelPath="/admin/pessoas/cidades"
  />
);
